import settings from "../utils/settings";
import SFError from "../models/SfError";
const useUpdateMerchantSetting = () => {
  const updateMerchant = async (data) => {
    const { token } = settings();
    try {
      const result = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/merchant-setting/self`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(data),
        }
      );
      if (!result.ok) {
        const jsonResult = await result.json();
        const error = new SFError({
          status: result.status,
          code: jsonResult.code,
          message: jsonResult.message,
        });

        return error.json();
      }
      const jsonResult = await result.json();

      return jsonResult;
    } catch (error) {
      return error;
    }
  };

  return { updateMerchant };
};

export default useUpdateMerchantSetting;
